import { useState, useEffect } from 'react';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { apiB2B, apiB2C } from '../api/axios-client';
import { redirectToGuestOrderTracker, redirectToSignIn, } from '../utils/http-helper';
import { ERR_REDIRECT } from '../constants/response-error-messages';
import { useReturnStore } from '../stores/returnStore';
export var useInterceptors = function () {
    var _a = useState(null), redirectError = _a[0], setRedirectError = _a[1];
    var isLoggedIn = useThdCustomer().isLoggedIn;
    var orderDetails = useReturnStore(function (state) { return state.orderDetailsV2; });
    var isMilitaryExchangeGuest = useReturnStore(function (state) { return state.isMilitaryExchangeGuest; });
    useEffect(function () {
        // Check for orderdetails data to see if data has been loaded & isGuest has been retrieved.
        // If guest is false, user has to be logged in. Otherwise, no need to check session.
        if (orderDetails) {
            apiB2B.interceptors.response.use(undefined, logonMiddleware);
            apiB2C.interceptors.response.use(undefined, logonMiddleware);
            if (!isMilitaryExchangeGuest) {
                if (!isLoggedIn) {
                    redirectToSignIn();
                    setRedirectError(ERR_REDIRECT);
                }
            }
        }
    }, [orderDetails]);
    var logonMiddleware = function (error) {
        var _a, _b, _c;
        var response = error.response;
        var endpointURL = (_a = response === null || response === void 0 ? void 0 : response.request) === null || _a === void 0 ? void 0 : _a.responseURL.split('/').at(-1);
        var flagExceptions = !['buyitagain', 'orderdetails'].includes(endpointURL);
        if (response &&
            flagExceptions &&
            (response.status === 401 || response.status === 431)) {
            // Messaging might change later once UX is looked into for redirected guest users
            setRedirectError(ERR_REDIRECT);
            if (isMilitaryExchangeGuest) {
                redirectToGuestOrderTracker();
            }
            else {
                // if checkEligibility call and invalid NET response, redirect back to order details page by going back in history
                var isCheckEligibilityCall = endpointURL.includes('checkEligibility');
                var isNetTokenExpired = (_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.errors) === null || _c === void 0 ? void 0 : _c.some(function (errorObj) { return errorObj.code === 'INVALID_NET_ERROR'; });
                if (isCheckEligibilityCall && isNetTokenExpired) {
                    window.history.back();
                }
                else {
                    redirectToSignIn();
                }
            }
        }
        return Promise.reject(error);
    };
    return {
        redirectError: redirectError,
    };
};
